import { render, staticRenderFns } from "./TeacherOtherNews.vue?vue&type=template&id=5be5b7be&scoped=true"
import script from "./TeacherOtherNews.vue?vue&type=script&lang=js"
export * from "./TeacherOtherNews.vue?vue&type=script&lang=js"
import style0 from "./TeacherOtherNews.vue?vue&type=style&index=0&id=5be5b7be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5b7be",
  null
  
)

export default component.exports